"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileHandler = void 0;
// Mobile Handler
const mobileHandler_constants_1 = require("./mobileHandler.constants");
class MobileHandler {
    constructor(deviceConnector) {
        this._requests = {};
        this.getResponse = (type, data) => {
            if (!this._requests[type]) {
                throw new Error(`Type: ${type} does not exist on requested types`);
            }
            this._requests[type](data);
            this._requests[type] = null;
        };
        this.createCallPromise = (timeout, type) => new Promise((resolve, reject) => {
            setTimeout(() => reject(new Error(`Timeout in request of type ${type}`)), timeout);
            if (type) {
                this._requests[type] = (data) => resolve(data);
            }
        });
        this.isMobileConfigInitialized = (seconds = 0) => new Promise((resolve, reject) => {
            if (seconds >= mobileHandler_constants_1.TIMEOUT_TOOLS) {
                reject(new Error('Timeout loading mobile configuration'));
                return;
            }
            if (this.deviceConnector.areToolsLoaded()) {
                resolve(true);
                return;
            }
            setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                try {
                    yield this.isMobileConfigInitialized(seconds + mobileHandler_constants_1.SECONDS_TO_RECHECK_TOOLS);
                    resolve(true);
                }
                catch (e) {
                    reject(e);
                }
            }), mobileHandler_constants_1.TOOLS_TIME_CHECK);
        });
        this.checkDeviceConnectorAndRequestType = (type) => {
            if (!this.deviceConnector.isAnyoneListening()) {
                throw new Error('Invalid request, Mobile Handler has not being initialized');
            }
            if (this._requests[type]) {
                throw new Error(`Request of type ${type} is already defined`);
            }
        };
        this.init = () => __awaiter(this, void 0, void 0, function* () {
            yield this.isMobileConfigInitialized(0);
            this.deviceConnector.listen(this.getResponse);
        });
        this.call = (type, payload) => __awaiter(this, void 0, void 0, function* () {
            return this.callWithTimeout(type, mobileHandler_constants_1.TIMEOUT_REQUEST * mobileHandler_constants_1.MILISECONDS_IN_A_SECOND, payload);
        });
        this.callWithTimeout = (type, timeout, payload) => __awaiter(this, void 0, void 0, function* () {
            this.checkDeviceConnectorAndRequestType(type);
            const waiter = this.createCallPromise(timeout, type);
            this.deviceConnector.call(type, payload);
            return waiter;
        });
        this.deviceConnector = deviceConnector;
    }
}
exports.MobileHandler = MobileHandler;
//# sourceMappingURL=mobileHandler.js.map